var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 20,
    height: 20,
    viewBox: "0 0 226 226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.746,4.746) scale(0.958,0.958)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "#ffffff",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.26667,97.93333c0,18.05369 -6.41097,34.63363 -17.053,47.62774l44.9793,44.9793c1.96801,1.88948 2.76078,4.69528 2.07256,7.33527c-0.68822,2.64 -2.74989,4.70167 -5.38989,5.38989c-2.64,0.68822 -5.44579,-0.10455 -7.33527,-2.07256l-44.9793,-44.9793c-12.9941,10.64202 -29.57404,17.053 -47.62774,17.053c-41.51622,0 -75.33333,-33.81711 -75.33333,-75.33333c0,-41.51622 33.81711,-75.33333 75.33333,-75.33333c41.51622,0 75.33333,33.81711 75.33333,75.33333zM37.66667,97.93333c0,33.37359 26.89308,60.26667 60.26667,60.26667c33.37359,0 60.26667,-26.89307 60.26667,-60.26667c0,-33.37359 -26.89307,-60.26667 -60.26667,-60.26667c-33.37359,0 -60.26667,26.89308 -60.26667,60.26667z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,226v-226h226v226z",
    fill: "none",
    stroke: "none",
    strokeWidth: 0,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.93333,22.6c-41.51622,0 -75.33333,33.81711 -75.33333,75.33333c0,41.51622 33.81711,75.33333 75.33333,75.33333c18.05369,0 34.63363,-6.41097 47.62774,-17.053l44.9793,44.9793c1.88948,1.96801 4.69528,2.76078 7.33527,2.07256c2.64,-0.68822 4.70167,-2.74989 5.38989,-5.38989c0.68822,-2.64 -0.10455,-5.44579 -2.07256,-7.33527l-44.9793,-44.9793c10.64202,-12.9941 17.053,-29.57404 17.053,-47.62774c0,-41.51622 -33.81711,-75.33333 -75.33333,-75.33333zM97.93333,37.66667c33.37359,0 60.26667,26.89308 60.26667,60.26667c0,33.37359 -26.89307,60.26667 -60.26667,60.26667c-33.37359,0 -60.26667,-26.89307 -60.26667,-60.26667c0,-33.37359 26.89308,-60.26667 60.26667,-60.26667z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "miter"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.36282fda6987b1118e7c7bf5fa5e70f8.svg";
export { ForwardRef as ReactComponent };